import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as Actions from 'state/actions'
import Projects from './Projects.component'

const mapStateToProps = state => {
  return {
    agent: state.agent.active,
    agents: state.organisation?.active?.projects.filter(p => !p.projectId) || [],
    projects: state.organisation?.active?.versionsProjects || []
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectAgent: agent => dispatch(Actions.selectAgent(agent)),
    fetchProjectInfo: projectId => dispatch(Actions.fetchProjectInfo(projectId))
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Projects))
